<div class="flex flex-col max-w-240 md:min-w-160 -m-6">

    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg">{{ title }}</div>
        <button mat-icon-button (click)="dialogRef.close(false)" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>

    <div class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto">
        <p [innerHTML]="message |  bypassSecurityTrustHtml"></p>
    </div>

</div>
